import Vue from 'vue'

const uid = localStorage.uid;
const imDB = {
    state: {
        imMessageDB: {},
        unreadDB: JSON.stringify({}),
    },
    getters: {
        getImMsgDB: (state) => (arrKey) => {
            return state.imMessageDB[arrKey];
        },
        getUnreadMsg: (state) => (key) => {
            let item = JSON.parse(state.unreadDB)[key];
            return item ? item.num : 0;
        },
        getUnreadMsgData: (state) => (key) => {
            let item = JSON.parse(state.unreadDB)[key];
            return item ;
        },
        getUnreadMsgDB: (state) => {
            let db = JSON.parse(state.unreadDB);
            console.log("getUnreadMsgDB", db)
            let dbList = [];
            let total = 0;
            for (let i in db) {
                if (db[i].chatType === 'chat') {
                    dbList.unshift(db[i]);
                    total += db[i].num;
                }else{
                    if(db[i].atList){
                       if(db[i].atList.length){
                           dbList.unshift(db[i]);
                           total += db[i].num;
                       }
                    }
                }
            }
            dbList.sort(function (a,b) {
                return new Date(b.createTime) - new Date(a.createTime);
            })
            console.log("[dbList]:", {total, dbList});
            return {total, dbList};
        }
    },

    mutations: {
        INIT_IMSG_DB(state, arrKey) {        // init db
            if (state.imMessageDB[arrKey] == null) {
                state.imMessageDB[arrKey] = new Array();
                state.imMessageDB[arrKey + '_unreadNum'] = 0;
                state.imMessageDB[arrKey + '_groupInfoCache'] = null;
            }
        },
        SAVE_IM_MESSAGE(state, {key, reset, msg}) {
            let unreadDB = JSON.parse(state.unreadDB);
            console.log("[SAVE_IM_MESSAGE]", unreadDB, key, reset, msg)
            if (!unreadDB[key]) unreadDB[key] = {};
            if (reset) {
                unreadDB[key].num = 0;
                console.log("[bb]", unreadDB);
                if (unreadDB[key].atList) {
                    delete  unreadDB[key]
                }
            }
            if (msg) {
                let num = unreadDB[key].num + 1 || 1;
                if (msg.chatType === "groupChat") {
                    msg.atList = unreadDB[key].atList || [];
                    if (msg.msgType === "@me") {
                        msg.atList.push({
                            id: msg.from,
                            txt: msg.content,
                            headimg: msg.headimg,
                            createTime: msg.createTime,
                            groupName: msg.groupName,
                            groupHeadimg: msg.groupHeadimg,
                            userName: msg.userName,
                            chatId:msg.chatId
                        })
                    }
                }
                if (unreadDB[key].atList) {
                    msg.msgType = "@me"
                }
                unreadDB[key] = msg;

                console.log("reset", reset)

                if (!reset) {
                    unreadDB[key].num = num;
                } else {
                    unreadDB[key].num = 0;
                }
            }
            console.log("处理后的", unreadDB[key], reset)
            state.unreadDB = JSON.stringify(unreadDB);
            let uid = localStorage.uid;
            console.log("[unreadDB]", unreadDB)
            Vue.prototype.$post(`easemobIM/${uid}/cacheNotice`, {jsonMapper: JSON.stringify(unreadDB)}).then((res) => {
                console.log("消息保存成功！")
            })
        }
    },
    actions: {
        initImMessageDB({commit, arrKey}) {
            commit('INIT_IMSG_DB', arrKey);
        },
        saveImMessage({commit}, option) {
            console.log("key", option);
            commit('SAVE_IM_MESSAGE', option);
        },
    }
}

export default imDB
